/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var noop = function () { };
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-spriteAnimation");
var SpriteAnimation = /** @class */ (function (_super) {
    tslib_1.__extends(SpriteAnimation, _super);
    function SpriteAnimation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentFrame: props.startFrame || 0,
            spriteWidth: 0,
            spriteHeight: 0
        };
        _this.prevTime = 0;
        _this.unmounting = false;
        _this.propsUpdatedAt = 0;
        _this.animate = _this.animate.bind(_this);
        return _this;
    }
    SpriteAnimation.loadImage = function (url, callback) {
        if (url === void 0) { url = ""; }
        if (callback === void 0) { callback = function (err, img) { }; }
        var img = new Image();
        img.onload = function () {
            callback(null, img);
        };
        img.onerror = function (err) {
            callback(err);
        };
        img.src = url;
    };
    SpriteAnimation.prototype.loadSprite = function () {
        var _this = this;
        var _a = this.props, sprite = _a.sprite, width = _a.width, height = _a.height, _b = _a.direction, direction = _b === void 0 ? "horizontal" : _b, onError = _a.onError, onLoad = _a.onLoad, frameCount = _a.frameCount;
        var _c = this.state, isLoaded = _c.isLoaded, hasErrored = _c.hasErrored;
        if (!isLoaded && !hasErrored) {
            SpriteAnimation.loadImage(sprite, function (err, image) {
                if (err) {
                    onError && onError(err);
                    // @ts-ignore dont trigger update
                    _this.state.hasErrored = true;
                    return;
                }
                onLoad && onLoad();
                if (image && !_this.unmounting) {
                    _this.setState({
                        isLoaded: true,
                        maxFrames: frameCount ||
                            Math.floor(direction === "horizontal"
                                ? image.width / width
                                : image.height / height),
                        spriteWidth: image.width,
                        spriteHeight: image.height
                    });
                }
            });
        }
    };
    SpriteAnimation.prototype.componentDidMount = function () {
        this.loadSprite();
        this.propsUpdatedAt = Date.now();
    };
    SpriteAnimation.prototype.componentDidUpdate = function () {
        var _this = this;
        // eslint-disable-line max-statements
        if (!this.state.isLoaded) {
            return this.loadSprite();
        }
        var _a = this.props, _b = _a.shouldAnimate, shouldAnimate = _b === void 0 ? true : _b, stopLastFrame = _a.stopLastFrame, _c = _a.onEnd, onEnd = _c === void 0 ? noop : _c;
        if (shouldAnimate) {
            var _d = this.state, _e = _d.maxFrames, maxFrames = _e === void 0 ? 0 : _e, currentFrame = _d.currentFrame;
            var nextFrame_1 = currentFrame + 1 >= maxFrames ? 0 : currentFrame + 1;
            if (nextFrame_1 === 0 && stopLastFrame) {
                if (this.animationId) {
                    cancelAnimationFrame(this.animationId);
                }
                return onEnd && onEnd();
            }
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
            }
            this.animationId = requestAnimationFrame(function (time) {
                return _this.animate(nextFrame_1, time);
            });
        }
    };
    SpriteAnimation.prototype.getInterval = function () {
        var _a = this.props.fps, fps = _a === void 0 ? 60 : _a;
        return 1000 / fps;
    };
    SpriteAnimation.prototype.animate = function (nextFrame, time) {
        var _this = this;
        // eslint-disable-line max-statements
        if (this.unmounting) {
            return;
        }
        if (!this.prevTime) {
            this.prevTime = time;
        }
        var delta = time - this.prevTime;
        if (delta < this.getInterval()) {
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
            }
            this.animationId = requestAnimationFrame(function (animTime) {
                return _this.animate(nextFrame, animTime);
            });
            return;
        }
        var _a = this.props.startDelay, startDelay = _a === void 0 ? 0 : _a;
        if (Date.now() - this.propsUpdatedAt < startDelay) {
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
            }
            this.animationId = requestAnimationFrame(function (animTime) {
                return _this.animate(0, animTime);
            });
            return;
        }
        this.prevTime = time - (delta % this.getInterval());
        this.setState({ currentFrame: nextFrame });
    };
    SpriteAnimation.prototype.componentWillReceiveProps = function (_a) {
        var sprite = _a.sprite, startDelay = _a.startDelay, reset = _a.reset, _b = _a.startFrame, startFrame = _b === void 0 ? 0 : _b;
        var _c = this.props, lastSprite = _c.sprite, lastStartDelay = _c.startDelay;
        var newState = {};
        this.setState({
            isLoaded: sprite !== lastSprite ? false : this.state.isLoaded,
            hasErrored: sprite !== lastSprite ? false : this.state.hasErrored,
            currentFrame: reset ? startFrame : this.state.currentFrame || 0
        });
        if (startDelay !== lastStartDelay) {
            this.propsUpdatedAt = Date.now();
        }
    };
    SpriteAnimation.prototype.componentWillUnmount = function () {
        this.unmounting = true;
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
    };
    SpriteAnimation.prototype.getSpritePosition = function (frame, options) {
        if (frame === void 0) { frame = 0; }
        if (options === void 0) { options = {}; }
        // eslint-disable-line max-statements
        var direction = options.direction, _a = options.width, width = _a === void 0 ? 0 : _a, _b = options.height, height = _b === void 0 ? 0 : _b, wrapAfter = options.wrapAfter, _c = options.scale, scale = _c === void 0 ? 1 : _c;
        var isHorizontal = direction === "horizontal";
        var row;
        var col;
        if (typeof wrapAfter === "undefined") {
            row = isHorizontal ? 0 : frame;
            col = isHorizontal ? frame : 0;
        }
        else {
            row = isHorizontal ? Math.floor(frame / wrapAfter) : frame % wrapAfter;
            col = isHorizontal ? frame % wrapAfter : Math.floor(frame / wrapAfter);
        }
        var cssWidth = (-width * col) / scale;
        var cssHeight = (-height * row) / scale;
        return cssWidth + "px " + cssHeight + "px";
    };
    SpriteAnimation.prototype.reset = function () {
        this.setState({
            currentFrame: this.props.startFrame || 0
        });
    };
    SpriteAnimation.prototype.render = function () {
        var _a = this.props, sprite = _a.sprite, width = _a.width, height = _a.height, className = _a.className, _b = _a.scale, scale = _b === void 0 ? 1 : _b;
        var _c = this.state, isLoaded = _c.isLoaded, currentFrame = _c.currentFrame, spriteWidth = _c.spriteWidth, spriteHeight = _c.spriteHeight;
        var blockStyle = {
            backgroundImage: isLoaded ? "url(" + sprite + ")" : undefined,
            backgroundPosition: isLoaded
                ? this.getSpritePosition(currentFrame, this.props)
                : undefined,
            backgroundSize: spriteWidth / scale + "px " + spriteHeight / scale + "px",
            width: width / scale + "px",
            height: height / scale + "px"
        };
        return (React.createElement("div", { className: classnames(moduleClassName(), className), style: blockStyle }));
    };
    SpriteAnimation.propTypes = {
        className: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        sprite: PropTypes.string,
        scale: PropTypes.number,
        startDelay: PropTypes.number,
        direction: PropTypes.string,
        shouldAnimate: PropTypes.bool,
        loop: PropTypes.bool,
        startFrame: PropTypes.number,
        fps: PropTypes.number,
        reset: PropTypes.bool,
        stopLastFrame: PropTypes.bool,
        onError: PropTypes.func,
        onLoad: PropTypes.func,
        onEnd: PropTypes.func,
        frameCount: PropTypes.number,
        wrapAfter: PropTypes.number
    };
    SpriteAnimation.defaultProps = {
        scale: 1,
        direction: "horizontal",
        shouldAnimate: true,
        loop: true,
        startFrame: 0,
        startDelay: 0,
        fps: 60,
        onError: noop,
        onLoad: noop,
        onEnd: noop
    };
    return SpriteAnimation;
}(React.Component));
exports.SpriteAnimation = SpriteAnimation;